import { Route, Switch } from 'react-router-dom';

const AdminLayout = (props) => {
	const { routes } = props;

	return (
		<div>
			<h1>Estamos en Admin Layout...</h1>
			<LoadRoutes routes={routes} />
		</div>
	);
};

export default AdminLayout;

function LoadRoutes({ routes }) {
	return (
		<Switch>
			{routes.map((route, index) => (
				<Route key={index} path={route.path} exact={route.exact} component={route.component} />
			))}
		</Switch>
	);
}
